
export default function AboutData(termLengths) {

    return {
        title: "What is Traditional Long-Term Care?",
        content: 'This insurance combines the benefit of traditional long-term care insurance with that of life insurance. These products provide greater flexibility than traditional Long-Term Care coverage as they have the ability to protect your retirement savings from health-related expenses as well as provide death benefit coverage.',
    }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/asset-based-ltc/AboutData.js